import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MateDriveService from "../../../../services/MateDriveService/MateDriveService";
import { getExtension } from "../../../../helpers/helper";
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import CloudDownloadOutlinedIcon from "@material-ui/icons/CloudDownloadOutlined";
import CreateNewFolderOutlinedIcon from "@material-ui/icons/CreateNewFolderOutlined";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import { useTranslation } from "react-i18next";
import DeleteModal from "./DeleteModal";

/**
 * @Description MateDrive Header design
 * @Param       flowId -  autom id
 * @Param       setRender - func
 * @Param       selectItem - selected item file or folder
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function Header({ selectItem, flowId, setRender, setSelectedItems, selectedItems }) {
  const [show, setShow] = useState(false);
  const [directoryName, setDirectoryName] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [fileValue, setFileValue] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const { t } = useTranslation();

  // create new directory
  async function handleCreateDirectory() {
    if (selectItem?.path !== undefined) {
      let newPath;
      if (!selectItem.is_dir) {
        let findCharIndex = selectItem.path.lastIndexOf("/");
        newPath = selectItem.path.substr(0, findCharIndex);
      } else {
        newPath = selectItem.path;
      }
      const resp = await MateDriveService.getFilterMateService(
        "CREATEDIRECTORY",
        newPath,
        directoryName,
        "",
        flowId
      );
      if (resp) {
        if (resp.status) setRender(true);
      }
      setShow(!show);
    }
  }

  // file upload  *xlx , jpeg vs..
  async function handleFileUpload() {
    let newPath = selectItem?.path === undefined ? "" : selectItem?.path;
    const resp = await MateDriveService.uploadFile(fileValue, newPath, flowId);
    if (resp) {
      if (resp.status){
        setFileValue("");
        setInputValue("");
        setRender(true);
       
      }
    }
  }

  // upload file control
  const handleChange = (event) => {
    if (event.target.files[0]?.name) {
      setFileValue(event.target.files[0]);
      const fullName = event.target.files[0].name;
      setInputValue(fullName);
    }
  };

  // delete selected item file or folder
  async function handleDelete() {
    if (
      selectItem?.name !== "Root" &&
      selectItem?.path !== null &&
      selectItem?.path !== undefined
    )
      setOpenDeleteModal(true);
  }

  // download selected item file
  async function handleDownload() {
    if (selectItem?.path !== null && selectItem?.path !== undefined) {
      let newPath = selectItem.path.replace(selectItem.name, "");
      const resp = await MateDriveService.getFilterMateService(
        "DOWNLOADFILE",
        newPath,
        selectItem.name,
        "",
        flowId
      );
      if (resp) {
        let bytes = new Uint8Array(resp.files[0].data);
        let ext = getExtension(selectItem.name);
        let blob = new Blob([bytes], { type: `application/${ext}` }); // change resultByte to bytes
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = selectItem.name;
        link.click();
      }
    }
  }

  return (
    <Grid
      item
      xs={12}
      spacing={2}
      style={{ borderBottom: "1px solid var(--celeste)" }}
    >
      <div className="matedrive-header" style={{cursor:"context-menu"}}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Button onClick={() => selectItem && setShow(!show)}>
            <CreateNewFolderOutlinedIcon />{" "}
            {t("CONTENT.MATE-DRIVE.NEW-DIRECTORY")}
          </Button>
          <div className="mate-drive-center">
            <label htmlFor="file-upload" className="mate-drive-center">
              <CloudUploadOutlinedIcon /> {t("CONTENT.MATE-DRIVE.UPLOAD")}
            </label>
            <input
              id="file-upload"
              type="file"
              onChange={handleChange}
              // accept={options.fileType}
            />
          </div>
          <div>
            {inputValue?.length > 0 ? (
              <>
                <Button
                  variant="outlined"
                  color="primary"
                  style={{ marginLeft: 5 }}
                  onClick={() => handleFileUpload()}
                >
                  {t("CONTENT.MATE-DRIVE.UPLOAD")}
                </Button>
                <small style={{ marginLeft: 10 }}>{inputValue}</small>
              </>
            ) : null}
          </div>
        </div>
        <div>
          <Button
            style={{ alignItems: "right" }}
            disabled={selectItem?.name === "Root"}
            onClick={() => handleDelete()}
          >
            <DeleteOutlineOutlinedIcon /> {t("CONTENT.MATE-DRIVE.DELETE")}
          </Button>
          <Button
            style={{ alignItems: "right" }}
            disabled={!selectItem}
            onClick={() => handleDownload()}
          >
            <CloudDownloadOutlinedIcon /> {t("CONTENT.MATE-DRIVE.DOWNLOAD")}
          </Button>
        </div>
      </div>
      {show ? (
        <div className="matedrive-header-create">
          <TextField
            id="outlined-basic"
            variant="outlined"
            value={directoryName}
            onChange={(e) => setDirectoryName(e.target.value)}
          />
          <Button
            variant="outlined"
            color="primary"
            style={{ marginLeft: 5 }}
            onClick={() => handleCreateDirectory()}
          >
            {t("CONTENT.MATE-DRIVE.CREATE")}
          </Button>
        </div>
      ) : null}
      {openDeleteModal && (
        <DeleteModal
          setOpen={setOpenDeleteModal}
          setRender={setRender}
          selectItem={selectItem}
          selectedItems={selectedItems}
          flowId={flowId}
        />
      )}
    </Grid>
  );
}
